import { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import Button from "../../designSystem/Button/Button";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import TextField from "../../designSystem/TextField";
import { useForm } from "react-hook-form";
import RadioButton from "../../designSystem/RadioButton";
import "./LoadSheetModal.css";
import Productdesp from "../../Order/OrderTaking/Productdesp";
import { GenerateOrder } from "../../../context/OrderContext";

const LoadSheetModal = () => {
    const [showModal, setShowModal] = useState(false);
    const { register } = useForm()

    return (
        <>
            <Button style={{ width: "42px" }} variant='success-light' size="sm" onClick={() => setShowModal(true)}>
                <LocalPrintshopIcon sx={{ color: "#007204" }} />
            </Button>
            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Load Sheet - 274839</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="box_with_title">
                        <p className="title">Account Info</p>
                        <Row>
                            <Col><TextField {...register("attention")} label="Attention" /> </Col>
                            <Col><TextField {...register("driver")} label="Driver" /> </Col>
                            <Col><TextField {...register("loadNumber")} label="Load Number" /> </Col>
                        </Row>
                        <Row>
                            <Col><TextField {...register("carrier")} label="Carrier" /> </Col>
                            <Col><TextField {...register("driver")} label="Driver" /> </Col>
                        </Row>
                        <Row>
                            <Col><TextField {...register("phone")} label="Phone Number" /> </Col>
                            <Col><TextField {...register("fax")} label="Fax" /> </Col>
                        </Row>
                    </div>
                    <Row className="input_container">
                        <Col sm={12} md={6} className="d-flex align-items-center gap-2">
                            <Col md={5}> <span>Dispatcher Name</span></Col>
                            <Col md={7}>
                                <input className="custom_input" {...register("tripNumber")} label="Trip Number" />
                            </Col>
                        </Col >
                        <Col sm={12} md={6} className="d-flex">
                            <Col md={5}> <span>Trip Number</span></Col>
                            <Col md={7}>
                                <input className="custom_input" {...register("tripNumber")} label="Trip Number" />
                            </Col>
                        </Col>
                    </Row>
                    <div className="d-flex gap-3 p-3">
                        <RadioButton name="carrier" label="Carrier Dock's" />
                        <RadioButton name="myDock" label="My Dock" />
                        <RadioButton name="customer" label="Customer" />
                    </div>
                    <div className="info_container">
                        <div className="mb-2">
                            <div className="info_item">
                                <h6 style={{ color: "#FFF", margin: 0 }}>Consignor/ Shipper Info</h6>
                            </div>
                            <Row>
                                <Col><TextField {...register("consignorName")} label="Consignor/Shipper" /> </Col>
                                <Col><TextField {...register("street")} label="Street #" /> </Col>
                                <Col><TextField {...register("streetName")} label="Street Name" /> </Col>
                                <Col><TextField {...register("unit")} label="Unit" /> </Col>
                            </Row>
                            <Row>
                                <Col><TextField {...register("country")} label="Country" /> </Col>
                                <Col><TextField {...register("province")} label="Province" /> </Col>
                                <Col><TextField {...register("city")} label="City" /> </Col>
                                <Col><TextField {...register("postalCode")} label="Postal Code" /> </Col>
                            </Row>
                            <Row>
                                <Col><TextField {...register("contactNumber")} label="Contact Number" /> </Col>
                                <Col><TextField {...register("phoneNumber")} label="Phone Number" /> </Col>
                            </Row>
                        </div>
                        <div className="mb-2">
                            <div className="info_item">
                                <h6 style={{ color: "#FFF", margin: 0 }}>Consignee/ Receiver Info</h6>
                            </div>
                            <Row>
                                <Col><TextField {...register("consigneeName")} label="Consignee/Receiver" /> </Col>
                                <Col><TextField {...register("street")} label="Street #" /> </Col>
                                <Col><TextField {...register("streetName")} label="Street Name" /> </Col>
                                <Col><TextField {...register("unit")} label="Unit" /> </Col>
                            </Row>
                            <Row>
                                <Col><TextField {...register("country")} label="Country" /> </Col>
                                <Col><TextField {...register("province")} label="Province" /> </Col>
                                <Col><TextField {...register("city")} label="City" /> </Col>
                                <Col><TextField {...register("postalCode")} label="Postal Code" /> </Col>
                            </Row>
                            <Row>
                                <Col><TextField {...register("contactNumber")} label="Contact Number" /> </Col>
                                <Col><TextField {...register("phoneNumber")} label="Phone Number" /> </Col>
                            </Row>
                        </div>
                        <div>
                            <div className="info_item">
                                <h6 style={{ color: "#FFF", margin: 0 }}>Consignee/ Receiver Info</h6>
                            </div>
                            <Row>
                                <Col><TextField {...register("consignorName")} label="Skid" /> </Col>
                                <Col><TextField {...register("street")} label="Pkgs" /> </Col>
                                <Col><TextField {...register("streetName")} label="Weight" /> </Col>
                                <Col><h6 style={{ color: "red" }}>Pkgs shipped on this trip</h6></Col>
                                <Col><TextField {...register("unit")} label="" /> </Col>
                                <Col>
                                    <GenerateOrder>
                                        <Productdesp sizeLg />
                                    </GenerateOrder>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <h6>Special Instructions</h6>
                    <div style={{ border: "1px solid grey", padding: "10px", borderRadius: "5px", marginBottom: "10px" }}>
                        <p>Please arrange P/UP today asap and hold at your dock for Sure truck. Any issues or concerns please advise asap thanks.</p>
                    </div>
                    <div className="d-flex gap-3 justify-content-between">
                        <Button variant="outline-primary">Email load sheet</Button>
                        <Button variant="outline-primary">Print Load Sheet</Button>
                        <Button variant="outline-primary">B.O.L</Button>
                        <Button >Cancel</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default LoadSheetModal;